import FiltersPopup from './FiltersPopup';
import './FiltersPopup.scss';

export default FiltersPopup;